import { render } from "./diabetes_notes.vue?vue&type=template&id=0a54ca24&scoped=true"
import script from "./diabetes_notes.vue?vue&type=script&lang=js"
export * from "./diabetes_notes.vue?vue&type=script&lang=js"

import "./diabetes_notes.vue?vue&type=style&index=0&id=0a54ca24&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a54ca24"]])

export default __exports__